module.exports = __webpack_public_path__ + "static/media/CITF-logo-BIL-700.4149acbd.png";